import React from "react";
import IntegrationMenuBar from "./IntegrationMenuBar";
import FlowEditorPage from "./flow/edit/FlowEditorPage";
import IntegrationListV2 from "./flow/list/IntegrationListV2";
import { Route, Routes } from "react-router-dom";

const IntegrationsPage = () => {
  const listPage = (
    <>
      <IntegrationMenuBar />
      <IntegrationListV2 />
    </>
  );
  const editorPage = (
    <>
      <IntegrationMenuBar />
      <FlowEditorPage />
    </>
  );

  return (
    <div className="ihub-main-view">
      <Routes>
        <Route index element={listPage} />
        <Route path=":flowId" element={editorPage} />
        <Route path=":flowId/:section/:sectionId" element={editorPage} />
        <Route path=":flowId/:section" element={editorPage} />
      </Routes>
    </div>
  );
};
export default IntegrationsPage;
